import { render, staticRenderFns } from "./customerAnalysisSelfSupport.vue?vue&type=template&id=9d4c1e0c&scoped=true"
import script from "./customerAnalysisSelfSupport.vue?vue&type=script&lang=js"
export * from "./customerAnalysisSelfSupport.vue?vue&type=script&lang=js"
import style0 from "./customerAnalysisSelfSupport.vue?vue&type=style&index=0&id=9d4c1e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4c1e0c",
  null
  
)

export default component.exports